export enum BreakDownDropdownOptionsEnums {
    TOTAL = "total",
    STAGE = "stage",
    KG = "kg"
}